import type { User } from "@shared/utils.user";
import { setUserSegment } from "@shared/utils.cookies";

export const deriveUserSegment = (
  user?: User | Record<string, never> | null
): void => {
  const userSegment = (() => {
    if (!user?.isLoggedIn) return "nonmember";
    return user?.hasMembership ? "member" : "lapsedmember";
  })();
  setUserSegment(userSegment);
};
